import { inject, observer } from 'mobx-react';
import * as React from 'react';
import {
  FormattedHTMLMessage,
  injectIntl,
  InjectedIntlProps
} from 'react-intl';
import Input from '../../../components/input/input';
import DataStore from '../../store/DataStore';
import messages from '../messages';
import Button, { ButtonType } from '../../../components/button/button';
import { RouterStore } from 'mobx-react-router';
import { match } from 'react-router';
import { ROUTE_START } from '../../../RouteList';
interface Iprops {
  dataStore?: DataStore;
  routing?: RouterStore;
  intl?: RouterStore;
  match?: match<any>;
}

@observer
class Form extends React.Component<Iprops & InjectedIntlProps, any> {
  state = {
    hasError: false
  };

  render() {
    const { hasError } = this.state;
    const {
      dataStore,
      intl,
      routing: { push }
    } = this.props;

    return (
      <>
        <div className="c-bubble__content">
          <div className="c-bubble__content-text">
            <FormattedHTMLMessage {...messages.loginIntro} />
          </div>
          <Input
            onChange={event => {
              dataStore.setUID(event.currentTarget.value);
            }}
            value={dataStore.uid}
            label={intl.formatMessage(messages.formLabelId)}
          />
          {hasError && (
            <div className="c-bubble__error-msg">
              <FormattedHTMLMessage {...messages.formErrorLogin} />
            </div>
          )}
        </div>
        <div className="c-bubble__nav-start">
          <Button
            onClick={async () => {
              try {
                const result = await dataStore.login();
                // console.log('dataStore', dataStore, result);

                if (result.status === 200) {
                  push(ROUTE_START);
                } else {
                  this.setState({ hasError: true });
                }
              } catch (error) {
                this.setState({ hasError: true });
              }
            }}
            type={ButtonType.primary}
            label={intl.formatMessage(messages.formButtonLogin)}
          />
        </div>
      </>
    );
  }
}
export default inject('dataStore', 'routing')(injectIntl(Form));



// WEBPACK FOOTER //
// ./src/containers/login/components/Form.tsx